import { useState } from 'react';
import { useNotify, useRedirect, TextInput, Form, SaveButton, required, useDataProvider, PasswordInput, useLogout } from 'react-admin';
import { Box, Card, CardContent, Typography } from '@mui/material';

// 添加密码校验
const validatePassword = (value: string) => {
    if (!value) {
        return '密码是必填项';
    }

    // 检查是否包含中文或全角字符
    const hasChineseOrFullWidth = /[\u4e00-\u9fa5\uFF00-\uFFFF]/.test(value);
    if (hasChineseOrFullWidth) {
        return '密码只能包含字母、数字以及英文标点符号';
    }

    // 检查长度
    if (value.length < 8 || value.length > 32) {
        return '密码长度应为8-32个字符之间';
    }



    return undefined;
};

export const ChangePassword = () => {
    const notify = useNotify();
    const logout = useLogout();
    const [loading, setLoading] = useState(false);
    const dataProvider = useDataProvider(); // 获取 dataProvider 实例

    const handleSubmit = (values: any) => {
        if (values.oldPassword === values.newPassword) {
            notify('新密码和旧密码不能相同，请重新输入', { type: 'error' });
            return;
        }

        if (values.newPassword !== values.confirmPassword) {
            notify('两次输入的密码不一致', { type: 'error' });
            return;
        }

        setLoading(true);

        // 使用 dataProvider 的 setPassword 方法
        dataProvider.setPassword(
            {}, // 资源类型（可以为空）
            {
                data: {
                    oldPassword: values.oldPassword,
                    newPassword: values.newPassword
                }
            }
        )
            .then(() => {
                notify('密码已修改成功，请重新登录', { type: 'success' });
                logout()
            })
            .catch((error: any) => {
                notify(error.message || '密码修改失败', { type: 'error' });
            })
            .finally(() => {
                setLoading(false);
            });
    };
    return (
        <Box display="flex" justifyContent="center" mt={5}>
            <Card sx={{ width: 450 }}>
                <CardContent>
                    <Typography variant="h5" gutterBottom>修改密码</Typography>
                    <Form onSubmit={handleSubmit}>
                        <PasswordInput
                            source="oldPassword"
                            validate={[required('请输入旧密码'), validatePassword]}
                            label="旧密码"
                            fullWidth
                            disabled={loading}
                        />
                        <PasswordInput
                            source="newPassword"
                            label="新密码"
                            fullWidth
                            validate={[required('请输入新密码'), validatePassword]}
                            disabled={loading}
                        />
                        <PasswordInput
                            source="confirmPassword"
                            label="确认密码"
                            fullWidth
                            validate={required('请再次输入新密码')}
                            disabled={loading}
                        />
                        <Box display="flex" justifyContent="flex-end" mt={2}>
                            <SaveButton label="保存" saving={loading} />
                        </Box>
                    </Form>
                </CardContent>
            </Card>
        </Box>
    );
};